export var state = {
  events: []
};